import { render, staticRenderFns } from "./BaseUploadMedia.vue?vue&type=template&id=4f9f0638&"
import script from "./BaseUploadMedia.vue?vue&type=script&lang=js&"
export * from "./BaseUploadMedia.vue?vue&type=script&lang=js&"
import style0 from "./BaseUploadMedia.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports